import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // если access умер → пробуем refresh
    if (
      error.response?.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const refresh = localStorage.getItem("refresh");

        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/token/refresh/`,
          { refresh }
        );

        const newAccess = res.data.access;

        localStorage.setItem("access", newAccess);

        // повторяем запрос
        originalRequest.headers.Authorization = `Bearer ${newAccess}`;

        return api(originalRequest);
      } catch (err) {
        // refresh тоже умер → logout
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");

        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
